import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import WSChat from 'components/chat/WSChat';
import Footer from 'components/no-auth/footer/Footer';
import BasePageForNoAuth from 'components/utils/BasePageForNoAuth';
import MessageBodyService from 'components/utils/MessageBodyService';

import { AUTH_SEND_MAIN_LINK, CHAT_ZENDESK } from 'constants/UrlConstants';

import { removeScript } from 'helpers/DOM';

import PromoSpinner from './common/PromoSpinner/PromoSpinner';
import HeaderFixed from './header-fixed/HeaderFixed';
import colors from '../../theme/colors';
import Popup from '../common/Popup/Popup';
import NotFound from '../NotFound';

const PageWrapper = styled.main`
    background-color: ${(props) => (props.useThemeColor ? props.theme.white : colors.white)};
    color: ${(props) => (props.useThemeColor ? props.theme.black : colors.black)};
    display: flex;
    flex-direction: column;
    flex: 1;
`;

const useZendeskChat = (isShowNavModal, renderOptions = {}) => {
    useEffect(() => {
        const addChat = () => {
            if (__isBrowser__) {
                const script = document.createElement('script');
                script.src = CHAT_ZENDESK;
                script.id = 'ze-snippet';
                document.body.appendChild(script);
            }
        };
        if (__isBrowser__ && renderOptions?.isBusinessConnect && !isShowNavModal) {
            if (document.readyState === 'complete') {
                addChat();
            } else {
                window.addEventListener('load', addChat, { once: true });
            }
        }
        return () => {
            if (renderOptions?.isBusinessConnect && !isShowNavModal) {
                removeScript(CHAT_ZENDESK);
            }
        };
    }, [renderOptions?.isBusinessConnect, isShowNavModal]);
};

export default function NotAuthBasePage(PageComponent) {
    const ComposedComponent = (props) => {
        const [backUrl, setBackUrl] = useState(AUTH_SEND_MAIN_LINK);
        const lang = props.noAuthFooter?.language?.lang ? props.noAuthFooter.language.lang : props.backendLang;
        const country = props.noAuthFooter?.language?.country ? props.noAuthFooter.language.country : props.backendCountry;
        const renderOptions = props.renderOptions;

        useEffect(() => {
            if (__isBrowser__ && document) {
                const referrer = document.referrer;
                const isFromAuth = referrer?.includes('/auth/');
                const savedPrevUrl = sessionStorage.getItem('prevUrl');

                if (isFromAuth && !savedPrevUrl) {
                    const backPath = new URL(referrer).pathname;
                    sessionStorage.setItem('prevUrl', backPath);
                    setBackUrl(backPath);
                } else if (savedPrevUrl) {
                    setBackUrl(savedPrevUrl);
                }
            }
        }, []);

        useZendeskChat(props.isShowNavModal, renderOptions);

        const renderChat = () => {
            if (
                renderOptions?.isGlobalAccount ||
                renderOptions?.isBusinessConnect ||
                renderOptions?.isApplePay ||
                renderOptions?.isHelpMobile ||
                !props.showZendeskChat
            ) {
                return null;
            }

            return <WSChat />;
        };

        if (props.notFound) {
            return <NotFound />;
        }

        const showHeader =
            !props.loading &&
            !renderOptions?.isHelpMobile &&
            !renderOptions?.hideHeader &&
            Array.isArray(props.newMenuObject) &&
            props.newMenuObject.length > 0;

        return (
            <>
                {showHeader && (
                    <HeaderFixed
                        loading={props.loading}
                        isShowNavModal={props.isShowNavModal}
                        menuSection={props.stateOptions?.menuSection}
                        data={props.newMenuObject}
                        pageName={props.stateOptions?.pageName}
                        promoDarkPage={renderOptions?.promoDarkPage}
                        libre={renderOptions?.isLibre}
                        hasChatButton={renderOptions?.hasChatButton}
                        isBlogPage={props.stateOptions?.section === 'blog'}
                    />
                )}
                <PageWrapper useThemeColor={renderOptions?.isHelpMobile} className={'lock_container'} style={{ opacity: `${props.loading ? '0.3' : '1'}` }}>
                    {!props.loading && <PageComponent {...props} data={props.data} loading={props.loading} renderOptions={renderOptions} backUrl={backUrl} />}
                </PageWrapper>
                <PromoSpinner forceShow={props.loading} />
                {!props.loading && !renderOptions?.isHelpMobile && (
                    <Footer renderOptions={renderOptions} data={props.noAuthFooter} lang={lang} country={country} isLanding={false} />
                )}
                {renderChat()}
                <MessageBodyService />
                <Popup />
                {props.isShowModal && props.modalComponent}
            </>
        );
    };

    const mapStateToProps = (state) => {
        return {
            noAuthFooter: state.extra.noAuthFooter,
            notFound: state.extra.notFound,
            isShowNavModal: state.app.isShowNavModal,
            modalComponent: state.app.modalComponent,
            isShowModal: state.app.isShowModal,
            lang: state.extra.noAuthFooter?.language?.lang,
            country: state.extra.noAuthFooter?.language?.country,
            newMenuObject: state.extra.newNoAuthMenu?.header,
            showZendeskChat: state.extra.noAuthFooter?.showZendeskChat,
        };
    };
    return connect(mapStateToProps)(BasePageForNoAuth(ComposedComponent));
}
